import React, { ComponentProps } from 'react'

export const QuestionCircleIcon = (props: ComponentProps<'svg'>) => (
    <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.50753 4.57774C7.33156 3.85645 8.6686 3.85645 9.49264 4.57774C10.3174 5.29904 10.3174 6.46859 9.49264 7.18989C9.34979 7.31585 9.19004 7.4193 9.02116 7.50093C8.4969 7.75496 8.00079 8.20393 8.00079 8.78659V9.31437M14.3334 7.73104C14.3334 8.56274 14.1696 9.3863 13.8513 10.1547C13.533 10.9231 13.0665 11.6213 12.4784 12.2094C11.8903 12.7975 11.1921 13.264 10.4237 13.5823C9.65535 13.9006 8.83179 14.0644 8.00008 14.0644C7.16838 14.0644 6.34481 13.9006 5.57642 13.5823C4.80802 13.264 4.10984 12.7975 3.52174 12.2094C2.93363 11.6213 2.46712 10.9231 2.14884 10.1547C1.83056 9.3863 1.66675 8.56274 1.66675 7.73104C1.66675 6.05133 2.33401 4.44043 3.52174 3.2527C4.70947 2.06497 6.32038 1.39771 8.00008 1.39771C9.67979 1.39771 11.2907 2.06497 12.4784 3.2527C13.6662 4.44043 14.3334 6.05133 14.3334 7.73104ZM8.00008 11.4255H8.00571V11.4311H8.00008V11.4255Z"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
)
